import { Directive, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core'
import { ConfirmationService } from 'primeng/api'
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog'
import { take } from 'rxjs/operators'
import { RichTextEditorComponent } from '../../../../misc'
import { CronEditorDialogComponent } from '../../cron-editor-dialog/cron-editor-dialog.component'
import { CodeWrapperDlgSrvcComponent } from '../../../../misc/components/code-editor/code-wrapper-dlg-srvc/code-wrapper-dlg-srvc.component'

@Directive()
export abstract class InlineEditDialogCellDirective implements OnChanges, OnDestroy {
  @Input() rowData: any
  @Input() fieldName: string
  @Input() editable: boolean
  @Input() mandatory: boolean
  @Input() header: string
  @Input() customEdit = false

  @Output() completeCellEdit: EventEmitter<any> = new EventEmitter()
  @Output() onCustomEdit: EventEmitter<any> = new EventEmitter()

  dialogRef: DynamicDialogRef

  constructor(
    private dialogService: DialogService,
    private confirmationService: ConfirmationService
  ) {}
  openEditorDialog(type: string, readOnly = false) {
    const dialogHeader = this.header + (readOnly ? ' (READ-ONLY)' : '')
    if (type === 'RichText') {
      this.dialogRef = this.dialogService.open(RichTextEditorComponent, {
        data: {
          text: this.rowData[this.fieldName],
          mandatory: this.mandatory,
          readOnly
        },
        header: dialogHeader,
        draggable: true,
        width: '80%'
      })
    } else if (type === 'Cron') {
      this.dialogRef = this.dialogService.open(CronEditorDialogComponent, {
        data: {
          cronExpression: this.rowData[this.fieldName]?.cronExpression,
          saveButtonLabel: 'Übernehmen'
        },
        header: dialogHeader,
        draggable: true,
        width: '80%'
      })
    } else {
      this.dialogRef = this.dialogService.open(CodeWrapperDlgSrvcComponent, {
        data: {
          syntax: type,
          code: this.rowData[this.fieldName],
          readOnly
        },
        header: dialogHeader,
        draggable: true,
        width: '80%',
        height: '80%'
      })
    }

    this.dialogRef.onClose.pipe(take(1)).subscribe((data: string) => {
      if (data !== undefined) {
        if (type === 'Cron') {
          this.rowData[this.fieldName] = { cronExpression: data, type: 'CronTrigger' }
        } else {
          this.rowData[this.fieldName] = data
        }
        // pass entity with edited data to inline edit save routine
        this.completeCellEdit.emit({ data: this.rowData, field: this.fieldName })
      }
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.editable === undefined && !changes.editable) {
      this.editable = true
    }
  }

  ngOnDestroy(): void {
    this.dialogRef?.destroy()
  }

  onDelete() {
    this.confirmationService.confirm({
      message: 'Sind Sie sicher, dass Sie dieses Feld leeren wollen?',
      header: 'Feld leeren',
      key: 'global',
      accept: () => {
        this.rowData[this.fieldName] = null
        this.completeCellEdit.emit({ data: this.rowData, field: this.fieldName })
      }
    })
  }

  onEdit(type: string, readOnly: boolean) {
    if (this.customEdit) {
      this.onCustomEdit.emit()
    } else {
      this.triggerEdit(type, readOnly)
    }
  }

  abstract triggerEdit(type: string, readOnly: boolean): void
}
